import React from 'react';
import './logoHolder.css'

function C2wSuperxLogoHolder( { className=null, svgLogo=null, bgColor=null } ) {
  return (
    <div className={className} style={{background: bgColor}}>
        {svgLogo}
    </div>
  )
}

export default C2wSuperxLogoHolder;
